import 'lazysizes';

require('prismjs/themes/prism-tomorrow.css');

import CustomLayout from './wrapPageElement';

export const wrapPageElement = CustomLayout;
